<template>
  <div>
    Messaging system down for maintenance.
  </div>
</template>
